// Syling navigation regarding the page user is on
const path = window.location.pathname;
const page = path.split('/').pop().replace('.html', '') || "index";

console.log(page);
const domain = window.location.origin;
const navItems = document.querySelectorAll('.navigation__nav-item');

const styleNav = (() => {
	navItems.forEach(item => {
		if (item.getAttribute('href').replace('.html', '') === page) {
			item.classList.add('navigation__nav-item--active');
			item.ariaCurrent = 'page';
		}
	});
})();


// Mobile navigation
const navToggler = document.querySelector('.navigation__toggler')
const navBar = document.querySelector('.navigation__bar')
const navBarContainer = document.querySelector('.navigation')

const toggleMobileNavigation = () => navBar.classList.toggle('visible')

const closeNavbar = e => {
	if (
		navBar.classList.contains('visible') &&
		e.target !== navToggler &&
		!navToggler.contains(e.target) &&
		e.target !== navBar &&
		!navBarContainer.contains(e.target)
	) {
		toggleMobileNavigation()
		document.body.removeEventListener('click', closeNavbar)
	} else if (!navBar.classList.contains('visible')) {
		document.body.removeEventListener('click', closeNavbar)
	}
}

navToggler.addEventListener('click', () => {
	toggleMobileNavigation()
	document.body.addEventListener('click', closeNavbar)
});

